// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IAgencyType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
    agencyPhoneNumber: string;
    agencyPhoneNumberExtension: string;
}

export class AgencyType implements IAgencyType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;
    public agencyPhoneNumber: string;
    public agencyPhoneNumberExtension: string;

    /**
		Returns Department of Economic Security (DES) AgencyType
	**/
    get DepartmentofEconomicSecurityDES(): IAgencyType {
        return this.FromId(1);
    }
    /**
		Returns Department of Economic Security (DES) - Child Support AgencyType
	**/
    get DepartmentofEconomicSecurityDESChildSupport(): IAgencyType {
        return this.FromId(2);
    }
    /**
		Returns Department of Revenue (DOR) AgencyType
	**/
    get DepartmentofRevenueDOR(): IAgencyType {
        return this.FromId(3);
    }
    /**
		Returns Arizona Attorney General's Office AgencyType
	**/
    get ArizonaAttorneyGeneralsOffice(): IAgencyType {
        return this.FromId(4);
    }
    /**
		Returns Apache County Attorney's Office AgencyType
	**/
    get ApacheCountyAttorneysOffice(): IAgencyType {
        return this.FromId(5);
    }
    /**
		Returns Cochise County Attorney's Office AgencyType
	**/
    get CochiseCountyAttorneysOffice(): IAgencyType {
        return this.FromId(6);
    }
    /**
		Returns Coconino County Attorney's Office AgencyType
	**/
    get CoconinoCountyAttorneysOffice(): IAgencyType {
        return this.FromId(7);
    }
    /**
		Returns Gila County Attorney's Office AgencyType
	**/
    get GilaCountyAttorneysOffice(): IAgencyType {
        return this.FromId(8);
    }
    /**
		Returns Graham County Attorney's Office AgencyType
	**/
    get GrahamCountyAttorneysOffice(): IAgencyType {
        return this.FromId(9);
    }
    /**
		Returns Greenlee County Attorney's Office AgencyType
	**/
    get GreenleeCountyAttorneysOffice(): IAgencyType {
        return this.FromId(10);
    }
    /**
		Returns La Paz County Attorney's Office AgencyType
	**/
    get LaPazCountyAttorneysOffice(): IAgencyType {
        return this.FromId(11);
    }
    /**
		Returns Maricopa County Attorney's Office AgencyType
	**/
    get MaricopaCountyAttorneysOffice(): IAgencyType {
        return this.FromId(12);
    }
    /**
		Returns Mohave County Attorney's Office AgencyType
	**/
    get MohaveCountyAttorneysOffice(): IAgencyType {
        return this.FromId(13);
    }
    /**
		Returns Navajo County Attorney's Office AgencyType
	**/
    get NavajoCountyAttorneysOffice(): IAgencyType {
        return this.FromId(14);
    }
    /**
		Returns Pima County Attorney's Office AgencyType
	**/
    get PimaCountyAttorneysOffice(): IAgencyType {
        return this.FromId(15);
    }
    /**
		Returns Pinal County Attorney's Office AgencyType
	**/
    get PinalCountyAttorneysOffice(): IAgencyType {
        return this.FromId(16);
    }
    /**
		Returns Santa Cruz Attorney's Office AgencyType
	**/
    get SantaCruzAttorneysOffice(): IAgencyType {
        return this.FromId(17);
    }
    /**
		Returns Yavapai County Attorney's Office AgencyType
	**/
    get YavapaiCountyAttorneysOffice(): IAgencyType {
        return this.FromId(18);
    }
    /**
		Returns Yuma County Attorney's Office AgencyType
	**/
    get YumaCountyAttorneysOffice(): IAgencyType {
        return this.FromId(19);
    }
    /**
		Returns See Accommodative Data AgencyType
	**/
    get SeeAccommodativeData(): IAgencyType {
        return this.FromId(20);
    }
    /**
		Returns Maricopa County Clerk of Court (collections) AgencyType
	**/
    get MaricopaCountyClerkOfCourtCollections(): IAgencyType {
        return this.FromId(21);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'DepartmentofEconomicSecurityDES', displayValue: 'Department of Economic Security (DES)', description: 'Department of Economic Security (DES)', sortOrder: 999999, active: true, agencyPhoneNumber: '6027710890', agencyPhoneNumberExtension: '' });
        this._dictionary.add('2', { id: 2, value: 'DepartmentofEconomicSecurityDESChildSupport', displayValue: 'Department of Economic Security (DES) - Child Support', description: 'Department of Economic Security (DES) - Child Support', sortOrder: 999999, active: true, agencyPhoneNumber: '6022524045', agencyPhoneNumberExtension: '' });
        this._dictionary.add('3', { id: 3, value: 'DepartmentofRevenueDOR', displayValue: 'Department of Revenue (DOR)', description: 'Department of Revenue (DOR)', sortOrder: 999999, active: true, agencyPhoneNumber: '6027167805', agencyPhoneNumberExtension: '' });
        this._dictionary.add('4', { id: 4, value: 'ArizonaAttorneyGeneralsOffice', displayValue: 'Arizona Attorney General\'s Office', description: 'Arizona Attorney General\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '6025425025', agencyPhoneNumberExtension: '' });
        this._dictionary.add('5', { id: 5, value: 'ApacheCountyAttorneysOffice', displayValue: 'Apache County Attorney\'s Office', description: 'Apache County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '9283377560', agencyPhoneNumberExtension: '' });
        this._dictionary.add('6', { id: 6, value: 'CochiseCountyAttorneysOffice', displayValue: 'Cochise County Attorney\'s Office', description: 'Cochise County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '5204328700', agencyPhoneNumberExtension: '' });
        this._dictionary.add('7', { id: 7, value: 'CoconinoCountyAttorneysOffice', displayValue: 'Coconino County Attorney\'s Office', description: 'Coconino County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '9286798200', agencyPhoneNumberExtension: '' });
        this._dictionary.add('8', { id: 8, value: 'GilaCountyAttorneysOffice', displayValue: 'Gila County Attorney\'s Office', description: 'Gila County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '9284028630', agencyPhoneNumberExtension: '' });
        this._dictionary.add('9', { id: 9, value: 'GrahamCountyAttorneysOffice', displayValue: 'Graham County Attorney\'s Office', description: 'Graham County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '9284283620', agencyPhoneNumberExtension: '' });
        this._dictionary.add('10', { id: 10, value: 'GreenleeCountyAttorneysOffice', displayValue: 'Greenlee County Attorney\'s Office', description: 'Greenlee County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '9288654108', agencyPhoneNumberExtension: '' });
        this._dictionary.add('11', { id: 11, value: 'LaPazCountyAttorneysOffice', displayValue: 'La Paz County Attorney\'s Office', description: 'La Paz County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '9286696118', agencyPhoneNumberExtension: '' });
        this._dictionary.add('12', { id: 12, value: 'MaricopaCountyAttorneysOffice', displayValue: 'Maricopa County Attorney\'s Office', description: 'Maricopa County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '6025060139', agencyPhoneNumberExtension: '' });
        this._dictionary.add('13', { id: 13, value: 'MohaveCountyAttorneysOffice', displayValue: 'Mohave County Attorney\'s Office', description: 'Mohave County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '9287530719', agencyPhoneNumberExtension: '' });
        this._dictionary.add('14', { id: 14, value: 'NavajoCountyAttorneysOffice', displayValue: 'Navajo County Attorney\'s Office', description: 'Navajo County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '9285244026', agencyPhoneNumberExtension: '' });
        this._dictionary.add('15', { id: 15, value: 'PimaCountyAttorneysOffice', displayValue: 'Pima County Attorney\'s Office', description: 'Pima County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '5207245600', agencyPhoneNumberExtension: '' });
        this._dictionary.add('16', { id: 16, value: 'PinalCountyAttorneysOffice', displayValue: 'Pinal County Attorney\'s Office', description: 'Pinal County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '5208666271', agencyPhoneNumberExtension: '' });
        this._dictionary.add('17', { id: 17, value: 'SantaCruzAttorneysOffice', displayValue: 'Santa Cruz Attorney\'s Office', description: 'Santa Cruz Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '5203757780', agencyPhoneNumberExtension: '' });
        this._dictionary.add('18', { id: 18, value: 'YavapaiCountyAttorneysOffice', displayValue: 'Yavapai County Attorney\'s Office', description: 'Yavapai County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '9287713344', agencyPhoneNumberExtension: '' });
        this._dictionary.add('19', { id: 19, value: 'YumaCountyAttorneysOffice', displayValue: 'Yuma County Attorney\'s Office', description: 'Yuma County Attorney\'s Office', sortOrder: 999999, active: true, agencyPhoneNumber: '9288174300', agencyPhoneNumberExtension: '' });
        this._dictionary.add('20', { id: 20, value: 'SeeAccommodativeData', displayValue: 'See Accommodative Data', description: 'See Accommodative Data', sortOrder: 999999, active: false, agencyPhoneNumber: '', agencyPhoneNumberExtension: '' });
        this._dictionary.add('21', { id: 21, value: 'MaricopaCountyClerkOfCourtCollections', displayValue: 'Maricopa County Clerk of Court (collections)', description: 'Maricopa County Clerk of Court (collections)', sortOrder: 999999, active: true, agencyPhoneNumber: '6025060073', agencyPhoneNumberExtension: '' });
        this._dictionary.add('22', { id: 22, value: 'BagdadYarnellJusticeCourt', displayValue: 'Bagdad-Yarnell Justice Court', description: 'Bagdad-Yarnell Justice Court', sortOrder: 999999, active: true, agencyPhoneNumber: '9284273318', agencyPhoneNumberExtension: '' });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IAgencyType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IAgencyType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IAgencyType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IAgencyType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IAgencyType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
